import { render, staticRenderFns } from "./Admissions.vue?vue&type=template&id=760ea8f4"
import script from "./Admissions.vue?vue&type=script&lang=js"
export * from "./Admissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports